import React from 'react';
import { Modal, Button } from 'antd';
import classnames from 'classnames';
import styles from './taskMail.module.scss';
import WarnIcon from '@web-common/components/UI/Icons/svgs/WarnSvg';
import { MailActions, useActions, ContactActions } from '@web-common/state/createStore';
import { getIn18Text } from 'api';
const TaskMailModal = (props) => {
    const { isModalVisible, setIsModalVisible, showTaskMail } = props;
    const ContactActionss = useActions(ContactActions);
    const { doModifyReceiver } = useActions(MailActions);
    const continueSend = (e) => {
        ContactActionss.doFocusSelector(getIn18Text('ZHENGWEN'));
        doModifyReceiver({ receiverType: 'bcc', receiver: [] });
        setIsModalVisible(false);
        showTaskMail();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { wrapClassName: "modal-dialog", onCancel: () => {
                setIsModalVisible(false);
            }, visible: isModalVisible, footer: null, closable: false },
            React.createElement("div", { className: "modal-content", style: { marginTop: '10px' } },
                React.createElement("div", { className: "modal-icon" },
                    React.createElement(WarnIcon, null)),
                React.createElement("div", { className: "modal-text" },
                    React.createElement("div", { className: classnames('desc', styles.taskModalDesc) }, getIn18Text('JIANCEDAONINTIAN')),
                    React.createElement("div", { className: classnames('btns', styles.taskModalBtns) },
                        React.createElement("div", null,
                            React.createElement(Button, { className: "cancel", onClick: () => {
                                    setIsModalVisible(false);
                                } }, getIn18Text('QUXIAO')),
                            React.createElement(Button, { danger: true, onClick: e => {
                                    continueSend(e);
                                } }, getIn18Text('SHANCHUBINGJIXU')))))))));
};
export default TaskMailModal;
